import { AdminRouteName } from '../../../CONSTANTS';
import GuaranteesTableRecords from '../../_partials/GuaranteesTableRecords';

const AwaitingPaymentPreApprovalGuarantees = (
  { TabsRaw }: any,
) => (
  <GuaranteesTableRecords
    type="pre-approval"
    TabsRaw={TabsRaw}
    defaultUrl={AdminRouteName.awaitingPaymentPreApprovalGuaranteesRoute}
    tabStatus="AWAITING_PAYMENT"
    toggleStorageId="awaiting-payment-pre-approval-guarantees-table-col"
    hasNameAndImage
    permissionName="can-view-awaiting-payment-guarantees"
  />
);
export default AwaitingPaymentPreApprovalGuarantees;
